export const getTrimmedUrl = (url: string) => {
    if (url && url?.indexOf('?') >= 0) {
        url = url?.substring(0, url?.indexOf('?'))
    }
    return url
}
